import { IContainer } from '../../../../forms/base/controls/containers/Container';
import { RPDF } from '../../../react-pdf';

export const Container: IContainer = ({ children }) => {
  return <RPDF.View>{children}</RPDF.View>;
};
